import { FormConfig } from './types';

export const globalInputsConfig: FormConfig = {
  title: 'Global Inputs',
  options: [],
  sectionsByOption: {
    default: [
      {
        title: '',
        collapsible: true,
        fields: [
          {
            label: 'Production Basin*',
            key: 'production_basin',
            type: 'select',
            options: ['Marcellus', 'Permian', 'User-Defined'],
            value: '',
          },
          {
            label: 'Liquefaction Facility*',
            type: 'select',
            key: 'liquefaction_facility',
            options: [
              { key: 'ccl', label: 'Gulf Coast', value: 'ccl' },
              { key: 'spl', label: 'East Coast', value: 'spl' },
            ],
            value: '',
          },
          {
            label: 'GWP*',
            type: 'select',
            key: 'gwp',
            options: ['20 years', '100 years'],
            value: '',
          },
          {
            label: 'Shipping Destination*',
            type: 'select',
            key: 'shipping_destination',
            options: [
              'Dalian, China',
              'Shanghai, China',
              'Tokyo, Japan',
              'Osaka, Japan',
              'Incheon, South Korea',
              'Busan, South Korea',
              'Cochin, India',
              'Singapore',
              'London, UK',
              'Amsterdam, Netherlands',
              'Barcelona, Spain',
              'Dublin, Ireland',
            ],
            value: '',
          },
          {
            label: 'Emission Allocation Method*',
            key: 'allocation_method_selection',
            type: 'select',
            options: [
              {
                key: 'first_method',
                label: 'Fully assigned to LNG',
                value: 'First Allocation Method',
              },
              {
                key: 'second_method',
                label: 'Energy-based emission allocation',
                value: 'Second Allocation Method',
              },
            ],
            value: '',
          },
        ],
      },
    ],
  },
};

export const productionConfig: FormConfig = {
  title: 'Pre-production and Production',
  options: ['Measurement-Informed', 'Inventory-Informed'],
  key: 'production_measurement_informed',
  value: 'Measurement-Informed',
  sectionsByOption: {
    'Measurement-Informed': [
      {
        title: 'Pre-production',
        collapsible: true,
        fields: [
          {
            label: 'Diesel used for well drilling, HF, and wastewater disposal',
            type: 'text',
            key: 'pre_production.diesel_emissions',
            unit: 'bbl/well',
            value: '153927',
          },
          {
            label: 'Flow back gas sent to flare or directly vented?',
            type: 'select',
            key: 'pre_production.gas_disposal_method',
            options: ['Sent to flare', 'Directly vented'],
            value: 'Sent to flare',
          },
          {
            label: 'Flow back gas volume',
            type: 'text',
            key: 'pre_production.flow_back_gas_volume',
            unit: 'Mcf/well',
            value: '190',
          },
          {
            label: 'Gas estimated ultimate recovery',
            type: 'text',
            key: 'pre_production.gas_estimated_ultimate_recovery',
            unit: 'Bcf/well',
            value: '5.12',
          },
          {
            label: 'Crude oil ultimate recovery',
            type: 'text',
            key: 'pre_production.crude_oil_ultimate_recovery',
            unit: 'bbl/well',
            value: '0',
          },
        ],
      },
      {
        title: 'Measurement informed methane emission rate',
        collapsible: true,
        fields: [
          {
            label: 'Measured methane emission rate',
            unit: 'CH4 emitted/CH4 production in gross gas',
            type: 'text',
            key: 'production.production_ch4_emission_rate',
            value: '0.004',
          },
        ],
      },
      {
        title: 'Fuel Use',
        collapsible: true,
        fields: [
          {
            label: 'Fuel gas for combustion',
            unit: 'Mcf/yr',
            key: 'production.production_gas_combustion',
            type: 'text',
            value: '9100',
          },
          {
            label: 'Fuel gas for compression',
            unit: 'Mcf/yr',
            key: 'production.production_gas_compression',
            type: 'text',
            value: '170',
          },
        ],
      },
      {
        title: 'Acid gas Removal',
        collapsible: true,
        fields: [
          {
            label: 'Acid gas removal CH4 emissions',
            unit: 'Ton/yr',
            key: 'production.production_gas_removal_ch4',
            type: 'text',
            value: '0',
          },
          {
            label: 'Acid gas removal CO2 emissions',
            unit: 'Ton/yr',
            key: 'production.production_gas_removal_co2',
            type: 'text',
            value: '0',
          },
        ],
      },
      {
        title: 'Flaring',
        collapsible: true,
        fields: [
          {
            label: 'Flaring CH4 emissions',
            unit: 'Ton/yr',
            key: 'production.production_flaring_ch4',
            type: 'text',
            value: '0',
          },
          {
            label: 'Flaring CO2 emissions',
            unit: 'Ton/yr',
            key: 'production.production_flaring_co2',
            type: 'text',
            value: '0',
          },
        ],
      },
      {
        title: 'Fugitives and Venting',
        collapsible: true,
        fields: [
          {
            label: 'Fugitives CH4 emissions',
            unit: 'Ton/yr',
            key: 'production.production_fugitives_ch4',
            type: 'text',
            value: '47709',
          },
          {
            label: 'Fugitives CO2 emissions',
            unit: 'Ton/yr',
            key: 'production.production_fugitives_co2',
            type: 'text',
            value: '0',
          },
          {
            label: 'Venting CH4 emissions',
            unit: 'Ton/yr',
            key: 'production.production_venting_ch4',
            type: 'text',
            value: '105100',
          },
          {
            label: 'Venting CO2 emissions',
            unit: 'Ton/yr',
            key: 'production.production_venting_co2',
            type: 'text',
            value: '0',
          },
        ],
      },
      {
        title: 'Production Throughput',
        collapsible: true,
        fields: [
          {
            label: 'Produced gas',
            unit: 'Mcf/yr',
            key: 'production.production_produced_gas',
            type: 'text',
            value: '7840000000',
          },
          {
            label: 'Crude oil separated',
            unit: 'Bbl/yr',
            key: 'production.production_crude_oil_separated',
            type: 'text',
            value: '0',
          },
        ],
      },
    ],
    'Inventory-Informed': [
      {
        title: 'Pre-production',
        collapsible: true,
        fields: [
          {
            label: 'Diesel used for well drilling, HF, and wastewater disposal',
            type: 'text',
            key: 'pre_production.diesel_emissions',
            unit: 'bbl/well',
            value: '153927',
          },
          {
            label: 'Flow back gas sent to flare or directly vented?',
            type: 'select',
            key: 'pre_production.gas_disposal_method',
            options: ['Sent to flare', 'Directly vented'],
            value: 'Sent to flare',
          },
          {
            label: 'Flow back gas volume',
            type: 'text',
            key: 'pre_production.flow_back_gas_volume',
            unit: 'Mcf/well',
            value: '190',
          },
          {
            label: 'Gas estimated ultimate recovery',
            type: 'text',
            key: 'pre_production.gas_estimated_ultimate_recovery',
            unit: 'Bcf/well',
            value: '5.12',
          },
          {
            label: 'Crude oil ultimate recovery',
            type: 'text',
            key: 'pre_production.crude_oil_ultimate_recovery',
            unit: 'bbl/well',
            value: '0',
          },
        ],
      },
      {
        title: 'Fuel Use',
        collapsible: true,
        fields: [
          {
            label: 'Fuel gas for combustion',
            unit: 'Mcf/yr',
            key: 'production.production_gas_combustion',
            type: 'text',
            value: '9100',
          },
          {
            label: 'Fuel gas for compression',
            unit: 'Mcf/yr',
            key: 'production.production_gas_compression',
            type: 'text',
            value: '170',
          },
        ],
      },
      {
        title: 'Acid gas Removal',
        collapsible: true,
        fields: [
          {
            label: 'Acid gas removal CH4 emissions',
            unit: 'Ton/yr',
            key: 'production.production_gas_removal_ch4',
            type: 'text',
            value: '0',
          },
          {
            label: 'Acid gas removal CO2 emissions',
            unit: 'Ton/yr',
            key: 'production.production_gas_removal_co2',
            type: 'text',
            value: '0',
          },
        ],
      },
      {
        title: 'Flaring',
        collapsible: true,
        fields: [
          {
            label: 'Flaring CH4 emissions',
            unit: 'Ton/yr',
            key: 'production.production_flaring_ch4',
            type: 'text',
            value: '0',
          },
          {
            label: 'Flaring CO2 emissions',
            unit: 'Ton/yr',
            key: 'production.production_flaring_co2',
            type: 'text',
            value: '0',
          },
        ],
      },
      {
        title: 'Fugitives and Venting',
        collapsible: true,
        fields: [
          {
            label: 'Fugitives CH4 emissions',
            unit: 'Ton/yr',
            key: 'production.production_fugitives_ch4',
            type: 'text',
            value: '47709',
          },
          {
            label: 'Fugitives CO2 emissions',
            unit: 'Ton/yr',
            key: 'production.production_fugitives_co2',
            type: 'text',
            value: '0',
          },
          {
            label: 'Venting CH4 emissions',
            unit: 'Ton/yr',
            key: 'production.production_venting_ch4',
            type: 'text',
            value: '105100',
          },
          {
            label: 'Venting CO2 emissions',
            unit: 'Ton/yr',
            key: 'production.production_venting_co2',
            type: 'text',
            value: '0',
          },
        ],
      },
      {
        title: 'Production Throughput',
        collapsible: true,
        fields: [
          {
            label: 'Produced gas',
            unit: 'Mcf/yr',
            key: 'production.production_produced_gas',
            type: 'text',
            value: '7840000000',
          },
          {
            label: 'Crude oil separated',
            unit: 'Bbl/yr',
            key: 'production.production_crude_oil_separated',
            type: 'text',
            value: '0',
          },
        ],
      },
    ],
  },
};

export const gatheringConfig: FormConfig = {
  title: 'Gathering and Boosting',
  key: 'gathering_measurement_informed',
  options: ['Measurement-Informed', 'Inventory-Informed'],
  value: 'Measurement-Informed',
  sectionsByOption: {
    'Measurement-Informed': [
      {
        title: 'Measurement informed methane emission rate',
        collapsible: true,
        fields: [
          {
            label: 'Measured methane emission rate',
            unit: 'CH4 emitted/CH4 production in gross gas',
            type: 'text',
            key: 'gathering.gathering_ch4_emission_rate',
            value: '0.004067354',
          },
        ],
      },
      {
        title: 'Fuel Use',
        collapsible: true,
        fields: [
          {
            label: 'Fuel gas for combustion',
            unit: 'Mcf/yr',
            key: 'gathering.gathering_gas_combustion',
            value: '819600',
            type: 'text',
          },
          {
            label: 'Fuel gas for compression',
            unit: 'Mcf/yr',
            key: 'gathering.gathering_gas_compression',
            value: '15026000',
            type: 'text',
          },
        ],
      },
      {
        title: 'Acid gas Removal',
        collapsible: true,
        fields: [
          {
            label: 'Acid gas removal CH4 emissions',
            unit: 'Ton/yr',
            key: 'gathering.gathering_gas_removal_ch4',
            value: '0',
            type: 'text',
          },
          {
            label: 'Acid gas removal CO2 emissions',
            unit: 'Ton/yr',
            key: 'gathering.gathering_gas_removal_co2',
            value: '102',
            type: 'text',
          },
        ],
      },
      {
        title: 'Flaring',
        collapsible: true,
        fields: [
          {
            label: 'Flaring CH4 emissions',
            unit: 'Ton/yr',
            key: 'gathering.gathering_flaring_ch4',
            value: '469',
            type: 'text',
          },
          {
            label: 'Flaring CO2 emissions',
            unit: 'Ton/yr',
            key: 'gathering.gathering_flaring_co2',
            value: '45900',
            type: 'text',
          },
        ],
      },
      {
        title: 'Fugitives and Venting',
        collapsible: true,
        fields: [
          {
            label: 'Fugitives CH4 emissions',
            unit: 'Ton/yr',
            key: 'gathering.gathering_fugitives_ch4',
            value: '473',
            type: 'text',
          },
          {
            label: 'Fugitives CO2 emissions',
            unit: 'Ton/yr',
            key: 'gathering.gathering_fugitives_co2',
            value: '0',
            type: 'text',
          },
          {
            label: 'Venting CH4 emissions',
            unit: 'Ton/yr',
            key: 'gathering.gathering_venting_ch4',
            value: '3306.85',
            type: 'text',
          },
          {
            label: 'Venting CO2 emissions',
            unit: 'Ton/yr',
            key: 'gathering.gathering_venting_co2',
            value: '0',
            type: 'text',
          },
        ],
      },
      {
        title: 'G&B Throughput',
        collapsible: true,
        fields: [
          {
            label: 'Produced gas',
            unit: 'Mcf/yr',
            key: 'gathering.gathering_produced_gas',
            value: '683000000',
            type: 'text',
          },
          {
            label: 'Lease condensate separated',
            unit: 'Bbl/yr',
            key: 'gathering.gathering_lease_condensate_separated',
            value: '0',
            type: 'text',
          },
        ],
      },
    ],
    'Inventory-Informed': [
      {
        title: 'Fuel Use',
        collapsible: true,
        fields: [
          {
            label: 'Fuel gas for combustion',
            unit: 'Mcf/yr',
            key: 'gathering.gathering_gas_combustion',
            value: '819600',
            type: 'text',
          },
          {
            label: 'Fuel gas for compression',
            unit: 'Mcf/yr',
            key: 'gathering.gathering_gas_compression',
            value: '15026000',
            type: 'text',
          },
        ],
      },
      {
        title: 'Acid gas Removal',
        collapsible: true,
        fields: [
          {
            label: 'Acid gas removal CH4 emissions',
            unit: 'Ton/yr',
            key: 'gathering.gathering_gas_removal_ch4',
            value: '0',
            type: 'text',
          },
          {
            label: 'Acid gas removal CO2 emissions',
            unit: 'Ton/yr',
            key: 'gathering.gathering_gas_removal_co2',
            value: '102',
            type: 'text',
          },
        ],
      },
      {
        title: 'Flaring',
        collapsible: true,
        fields: [
          {
            label: 'Flaring CH4 emissions',
            unit: 'Ton/yr',
            key: 'gathering.gathering_flaring_ch4',
            value: '469',
            type: 'text',
          },
          {
            label: 'Flaring CO2 emissions',
            unit: 'Ton/yr',
            key: 'gathering.gathering_flaring_co2',
            value: '45900',
            type: 'text',
          },
        ],
      },
      {
        title: 'Fugitives and Venting',
        collapsible: true,
        fields: [
          {
            label: 'Fugitives CH4 emissions',
            unit: 'Ton/yr',
            key: 'gathering.gathering_fugitives_ch4',
            value: '473',
            type: 'text',
          },
          {
            label: 'Fugitives CO2 emissions',
            unit: 'Ton/yr',
            key: 'gathering.gathering_fugitives_co2',
            value: '0',
            type: 'text',
          },
          {
            label: 'Venting CH4 emissions',
            unit: 'Ton/yr',
            key: 'gathering.gathering_venting_ch4',
            value: '3306.85',
            type: 'text',
          },
          {
            label: 'Venting CO2 emissions',
            unit: 'Ton/yr',
            key: 'gathering.gathering_venting_co2',
            value: '0',
            type: 'text',
          },
        ],
      },
      {
        title: 'G&B Throughput',
        collapsible: true,
        fields: [
          {
            label: 'Produced gas',
            unit: 'Mcf/yr',
            key: 'gathering.gathering_produced_gas',
            value: '683000000',
            type: 'text',
          },
          {
            label: 'Lease condensate separated',
            unit: 'Bbl/yr',
            key: 'gathering.gathering_lease_condensate_separated',
            value: '0',
            type: 'text',
          },
        ],
      },
    ],
  },
};

export const processingConfig: FormConfig = {
  title: 'Processing',
  options: ['Measurement-Informed', 'Inventory-Informed'],
  key: 'processing_measurement_informed',
  value: 'Measurement-Informed',
  sectionsByOption: {
    'Measurement-Informed': [
      {
        title: 'Measurement informed methane emission rate',
        collapsible: true,
        fields: [
          {
            label: 'Measured methane emission rate',
            unit: 'CH4 emitted/CH4 production in gross gas',
            key: 'processing.processing_ch4_emission_rate',
            type: 'text',
            value: '0.00137',
          },
        ],
      },
      {
        title: 'Fuel Use',
        collapsible: true,
        fields: [
          {
            label: 'Fuel gas for combustion',
            unit: 'Mcf/yr',
            key: 'processing.processing_gas_combustion',
            type: 'text',
            value: '0',
          },
          {
            label: 'Fuel gas for compression',
            unit: 'Mcf/yr',
            key: 'processing.processing_gas_compression',
            type: 'text',
            value: '72460.72',
          },
        ],
      },
      {
        title: 'Acid gas Removal',
        collapsible: true,
        fields: [
          {
            label: 'Acid gas removal CH4 emissions',
            unit: 'Ton/yr',
            key: 'processing.processing_gas_removal_ch4',
            type: 'text',
            value: '25.68',
          },
          {
            label: 'Acid gas removal CO2 emissions',
            unit: 'Ton/yr',
            key: 'processing.processing_gas_removal_co2',
            type: 'text',
            value: '24600',
          },
        ],
      },
      {
        title: 'Flaring',
        collapsible: true,
        fields: [
          {
            label: 'Flaring CH4 emissions',
            unit: 'Ton/yr',
            key: 'processing.processing_flaring_ch4',
            type: 'text',
            value: '63.65',
          },
          {
            label: 'Flaring CO2 emissions',
            unit: 'Ton/yr',
            key: 'processing.processing_flaring_co2',
            type: 'text',
            value: '9229',
          },
        ],
      },
      {
        title: 'Fugitives and Venting',
        collapsible: true,
        fields: [
          {
            label: 'Fugitives CH4 emissions',
            unit: 'Ton/yr',
            key: 'processing.processing_fugitives_ch4',
            type: 'text',
            value: '19.4',
          },
          {
            label: 'Fugitives CO2 emissions',
            unit: 'Ton/yr',
            key: 'processing.processing_fugitives_co2',
            type: 'text',
            value: '0',
          },
          {
            label: 'Venting CH4 emissions',
            unit: 'Ton/yr',
            key: 'processing.processing_venting_ch4',
            type: 'text',
            value: '83.18',
          },
          {
            label: 'Venting CO2 emissions',
            unit: 'Ton/yr',
            key: 'processing.processing_venting_co2',
            type: 'text',
            value: '0',
          },
        ],
      },
      {
        title: 'Processing Throughput',
        collapsible: true,
        fields: [
          {
            label: 'Pipeline gas',
            unit: 'Mcf/yr',
            key: 'processing.pipeline_processing_gas',
            type: 'text',
            value: '34500000',
          },
          {
            label: 'NGL separated',
            unit: 'Bbl/yr',
            key: 'processing.ngl_separated',
            type: 'text',
            value: '239000',
          },
        ],
      },
    ],
    'Inventory-Informed': [
      {
        title: 'Fuel Use',
        collapsible: true,
        fields: [
          {
            label: 'Fuel gas for combustion',
            unit: 'Mcf/yr',
            key: 'processing.processing_gas_combustion',
            type: 'text',
            value: '0',
          },
          {
            label: 'Fuel gas for compression',
            unit: 'Mcf/yr',
            key: 'processing.processing_gas_compression',
            type: 'text',
            value: '72460.72',
          },
        ],
      },
      {
        title: 'Acid gas Removal',
        collapsible: true,
        fields: [
          {
            label: 'Acid gas removal CH4 emissions',
            unit: 'Ton/yr',
            key: 'processing.processing_gas_removal_ch4',
            type: 'text',
            value: '25.68',
          },
          {
            label: 'Acid gas removal CO2 emissions',
            unit: 'Ton/yr',
            key: 'processing.processing_gas_removal_co2',
            type: 'text',
            value: '24600',
          },
        ],
      },
      {
        title: 'Flaring',
        collapsible: true,
        fields: [
          {
            label: 'Flaring CH4 emissions',
            unit: 'Ton/yr',
            key: 'processing.processing_flaring_ch4',
            type: 'text',
            value: '63.65',
          },
          {
            label: 'Flaring CO2 emissions',
            unit: 'Ton/yr',
            key: 'processing.processing_flaring_co2',
            type: 'text',
            value: '9229',
          },
        ],
      },
      {
        title: 'Fugitives and Venting',
        collapsible: true,
        fields: [
          {
            label: 'Fugitives CH4 emissions',
            unit: 'Ton/yr',
            key: 'processing.processing_fugitives_ch4',
            type: 'text',
            value: '19.4',
          },
          {
            label: 'Fugitives CO2 emissions',
            unit: 'Ton/yr',
            key: 'processing.processing_fugitives_co2',
            type: 'text',
            value: '0',
          },
          {
            label: 'Venting CH4 emissions',
            unit: 'Ton/yr',
            key: 'processing.processing_venting_ch4',
            type: 'text',
            value: '83.18',
          },
          {
            label: 'Venting CO2 emissions',
            unit: 'Ton/yr',
            key: 'processing.processing_venting_co2',
            type: 'text',
            value: '0',
          },
        ],
      },
      {
        title: 'Processing Throughput',
        collapsible: true,
        fields: [
          {
            label: 'Pipeline gas',
            unit: 'Mcf/yr',
            key: 'processing.pipeline_processing_gas',
            type: 'text',
            value: '34500000',
          },
          {
            label: 'NGL separated',
            unit: 'Bbl/yr',
            key: 'processing.ngl_separated',
            type: 'text',
            value: '239000',
          },
        ],
      },
    ],
  },
};

export const transmissionConfig: FormConfig = {
  title: 'Transmission',
  key: 'transmission_measurement_informed',
  options: ['Measurement-Informed', 'Inventory-Informed'],
  value: 'Measurement-Informed',
  sectionsByOption: {
    'Measurement-Informed': [
      {
        title: 'Measurement informed methane emission rate',
        collapsible: true,
        fields: [
          {
            label:
              'Measured methane emission rate (reciprocating transmission station)',
            unit: 'CH4 emitted/CH4 production in gross gas',
            key: 'transmission.transmission_ch4_emission_rate_reciprocating_station',
            type: 'text',
            value: '0.000489',
          },
          {
            label:
              'Measured methane emission rate (centrifugal transmission station)',
            unit: 'CH4 emitted/CH4 production in gross gas',
            key: 'transmission.transmission_ch4_emission_rate_centrifugal_station',
            type: 'text',
            value: '0.00009973',
          },
          {
            label:
              'Measured methane emission rate (electric transmission station)',
            unit: 'CH4 emitted/CH4 production in gross gas',
            key: 'transmission.transmission_ch4_emission_rate_electric_station',
            type: 'text',
            value: '0',
          },
        ],
      },
      {
        title: 'Number of stations',
        collapsible: true,
        fields: [
          {
            label: 'Distance between processing plant to liquefaction facility',
            unit: 'miles',
            key: 'transmission.distance_between_processing_plant_lf',
            type: 'text',
            value: '1294',
            readonly: false, //true
          },
          {
            label: 'Distance between transmission stations',
            unit: 'miles',
            key: 'transmission.distance_between_transmission_stations',
            type: 'text',
            value: '55',
            readonly: false, //true
          },
          {
            label: 'Total number of transmission stations',
            unit: '',
            key: 'transmission.total_number_of_transmission_stations',
            type: 'text',
            value: '24',
            readonly: false, //true
          },
          {
            label: 'Number of reciprocating engine powered compressor stations',
            unit: '',
            key: 'transmission.number_of_reciprocating_engine_stations',
            type: 'text',
            value: '17',
          },
          {
            label: 'Number of centrifugal turbine powered compressor stations',
            unit: '',
            key: 'transmission.number_of_centrifugal_turbine_stations',
            type: 'text',
            value: '6',
          },
          {
            label: 'Number of electric powered compressor stations',
            unit: '',
            key: 'transmission.number_of_electric_powered_compressor_stations',
            type: 'text',
            value: '0',
          },
        ],
      },
      {
        title: 'Fuel Use',
        collapsible: true,
        fields: [
          {
            label:
              'Fuel gas combustion CO2 emissions at all reciprocating stations',
            unit: 'Ton/yr',
            key: 'transmission.fuel_gas_combustion_co2_reciprocating',
            type: 'text',
            value: '164417',
          },
          {
            label:
              'Fuel gas combustion CH4 emissions at all reciprocating stations',
            unit: 'Ton/yr',
            key: 'transmission.fuel_gas_combustion_ch4_reciprocating',
            type: 'text',
            value: '4519',
          },
          {
            label:
              'Fuel gas combustion CO2 emissions at all centrifugal stations',
            unit: 'Ton/yr',
            key: 'transmission.fuel_gas_combustion_co2_centrifugal',
            type: 'text',
            value: '152594',
          },
          {
            label:
              'Fuel gas combustion CH4 emissions at all centrifugal stations',
            unit: 'Ton/yr',
            key: 'transmission.fuel_gas_combustion_ch4_centrifugal',
            type: 'text',
            value: '35',
          },
        ],
      },
      {
        title: 'Fugitives & venting',
        collapsible: true,
        fields: [
          {
            label: 'Fugitives CH4 emissions',
            unit: 'Ton/yr',
            key: 'transmission.transmission_fugitives_ch4',
            type: 'text',
            value: '7620',
          },
          {
            label: 'Fugitives CO2 emissions',
            unit: 'Ton/yr',
            key: 'transmission.transmission_fugitives_co2',
            type: 'text',
            value: '0',
          },
          {
            label: 'Venting CH4 emissions',
            unit: 'Ton/yr',
            key: 'transmission.transmission_venting_ch4',
            type: 'text',
            value: '2167',
          },
          {
            label: 'Venting CO2 emissions',
            unit: 'Ton/yr',
            key: 'transmission.transmission_venting_co2',
            type: 'text',
            value: '0',
          },
        ],
      },
      {
        title: 'Transmission Throughput',
        collapsible: true,
        fields: [
          {
            label: 'Transmission pipeline gas throughput',
            unit: 'Mcf/yr',
            key: 'transmission.transmission_pipeline_gas_throughput',
            type: 'text',
            value: '124000000',
          },
        ],
      },
    ],
    'Inventory-Informed': [
      {
        title: 'Number of stations',
        collapsible: true,
        fields: [
          {
            label: 'Distance between processing plant to liquefaction facility',
            unit: 'miles',
            key: 'transmission.distance_between_processing_plant_lf',
            type: 'text',
            value: '1294',
          },
          {
            label: 'Distance between transmission stations',
            unit: 'miles',
            key: 'transmission.distance_between_transmission_stations',
            type: 'text',
            value: '55',
          },
          {
            label: 'Total number of transmission stations',
            unit: '',
            key: 'transmission.total_number_of_transmission_stations',
            type: 'text',
            value: '24',
          },
          {
            label: 'Number of reciprocating engine powered compressor stations',
            unit: '',
            key: 'transmission.number_of_reciprocating_engine_stations',
            type: 'text',
            value: '17',
          },
          {
            label: 'Number of centrifugal turbine powered compressor stations',
            unit: '',
            key: 'transmission.number_of_centrifugal_turbine_stations',
            type: 'text',
            value: '6',
          },
          {
            label: 'Number of electric powered compressor stations',
            unit: '',
            key: 'transmission.number_of_electric_powered_compressor_stations',
            type: 'text',
            value: '0',
          },
        ],
      },
      {
        title: 'Fuel Use',
        collapsible: true,
        fields: [
          {
            label:
              'Fuel gas combustion CO2 emissions at all reciprocating stations',
            unit: 'Ton/yr',
            key: 'transmission.fuel_gas_combustion_co2_reciprocating',
            type: 'text',
            value: '164417',
          },
          {
            label:
              'Fuel gas combustion CH4 emissions at all reciprocating stations',
            unit: 'Ton/yr',
            key: 'transmission.fuel_gas_combustion_ch4_reciprocating',
            type: 'text',
            value: '4519',
          },
          {
            label:
              'Fuel gas combustion CO2 emissions at all centrifugal stations',
            unit: 'Ton/yr',
            key: 'transmission.fuel_gas_combustion_co2_centrifugal',
            type: 'text',
            value: '152594',
          },
          {
            label:
              'Fuel gas combustion CH4 emissions at all centrifugal stations',
            unit: 'Ton/yr',
            key: 'transmission.fuel_gas_combustion_ch4_centrifugal',
            type: 'text',
            value: '35',
          },
        ],
      },
      {
        title: 'Fugitives & venting',
        collapsible: true,
        fields: [
          {
            label: 'Fugitives CH4 emissions',
            unit: 'Ton/yr',
            key: 'transmission.transmission_fugitives_ch4',
            type: 'text',
            value: '7620',
          },
          {
            label: 'Fugitives CO2 emissions',
            unit: 'Ton/yr',
            key: 'transmission.transmission_fugitives_co2',
            type: 'text',
            value: '0',
          },
          {
            label: 'Venting CH4 emissions',
            unit: 'Ton/yr',
            key: 'transmission.transmission_venting_ch4',
            type: 'text',
            value: '2167',
          },
          {
            label: 'Venting CO2 emissions',
            unit: 'Ton/yr',
            key: 'transmission.transmission_venting_co2',
            type: 'text',
            value: '0',
          },
        ],
      },
      {
        title: 'Transmission Throughput',
        collapsible: true,
        fields: [
          {
            label: 'Transmission pipeline gas throughput',
            unit: 'Mcf/yr',
            key: 'transmission.transmission_pipeline_gas_throughput',
            type: 'text',
            value: '124000000',
          },
        ],
      },
    ],
  },
};

export const liquefactionConfig: FormConfig = {
  title: 'Liquefaction',
  key: 'liquefaction_measurement_informed',
  options: ['Measurement-Informed', 'Inventory-Informed'],
  value: 'Measurement-Informed',
  sectionsByOption: {
    'Measurement-Informed': [
      {
        title: 'Measurement informed methane emission rate',
        collapsible: true,
        fields: [
          {
            label: 'Measured methane emission rate',
            unit: 'CH4 emitted/CH4 production in gross gas',
            key: 'liquefaction.liquefaction_ch4_emission_rate',
            type: 'text',
            value: '0.00024',
          },
        ],
      },
      {
        title: 'Fuel Use',
        collapsible: true,
        fields: [
          {
            label: 'Fuel gas combustion CO2 emissions',
            unit: 'Ton/yr',
            key: 'liquefaction.liquefaction_combustion_co2',
            type: 'text',
            value: '5236872',
          },
          {
            label: 'Fuel gas combustion CH4 emissions',
            unit: 'Ton/yr',
            key: 'liquefaction.liquefaction_combustion_ch4',
            type: 'text',
            value: '98.96',
          },
          // {
          //   label:
          //     'Fuel gas combustion CO2 emissions at all centrifugal transmission stations',
          //   unit: 'Ton/yr',
          //   key: 'liquefaction.fuel_gas_combustion_co2_centrifugal',
          //   type: 'text',
          //   value: '152594',
          // },
          // {
          //   label:
          //     'Fuel gas combustion CH4 emissions at all centrifugal transmission stations',
          //   unit: 'Ton/yr',
          //   key: 'liquefaction.fuel_gas_combustion_ch4_centrifugal',
          //   type: 'text',
          //   value: '35',
          // },
        ],
      },
      {
        title: 'Flaring',
        collapsible: true,
        fields: [
          {
            label: 'Flaring CH4 emissions',
            unit: 'Ton/yr',
            key: 'liquefaction.liquefaction_flaring_ch4',
            type: 'text',
            value: '816.54',
          },
          {
            label: 'Flaring CO2 emissions',
            unit: 'Ton/yr',
            key: 'liquefaction.liquefaction_flaring_co2',
            type: 'text',
            value: '369677',
          },
        ],
      },
      {
        title: 'Fugitives & venting',
        collapsible: true,
        fields: [
          {
            label: 'Fugitives CH4 emissions',
            unit: 'Ton/yr',
            key: 'liquefaction.liquefaction_fugitives_ch4',
            type: 'text',
            value: '159.79',
          },
          {
            label: 'Fugitives CO2 emissions',
            unit: 'Ton/yr',
            key: 'liquefaction.liquefaction_fugitives_co2',
            type: 'text',
            value: '0',
          },
          {
            label: 'Venting CH4 emissions',
            unit: 'Ton/yr',
            key: 'liquefaction.liquefaction_venting_ch4',
            type: 'text',
            value: '0',
          },
          {
            label: 'Venting CO2 emissions',
            unit: 'Ton/yr',
            key: 'liquefaction.liquefaction_venting_co2',
            type: 'text',
            value: '0',
          },
        ],
      },
      {
        title: 'Liquefaction Throughput',
        collapsible: true,
        fields: [
          {
            label: 'NG received',
            unit: 'Mcf/yr',
            key: 'liquefaction.liquefaction_throughput',
            type: 'text',
            value: '871837664',
          },
        ],
      },
    ],
    'Inventory-Informed': [
      {
        title: 'Fuel Use',
        collapsible: true,
        fields: [
          {
            label: 'Fuel gas combustion CO2 emissions',
            unit: 'Ton/yr',
            key: 'liquefaction.liquefaction_combustion_co2',
            type: 'text',
            value: '5236872',
          },
          {
            label: 'Fuel gas combustion CH4 emissions',
            unit: 'Ton/yr',
            key: 'liquefaction.liquefaction_combustion_ch4',
            type: 'text',
            value: '98.96',
          },
          // {
          //   label:
          //     'Fuel gas combustion CO2 emissions at all centrifugal transmission stations',
          //   unit: 'Ton/yr',
          //   key: 'liquefaction.fuel_gas_combustion_co2_centrifugal',
          //   type: 'text',
          //   value: '152594',
          // },
          // {
          //   label:
          //     'Fuel gas combustion CH4 emissions at all centrifugal transmission stations',
          //   unit: 'Ton/yr',
          //   key: 'liquefaction.fuel_gas_combustion_ch4_centrifugal',
          //   type: 'text',
          //   value: '35',
          // },
        ],
      },
      {
        title: 'Flaring',
        collapsible: true,
        fields: [
          {
            label: 'Flaring CH4 emissions',
            unit: 'Ton/yr',
            key: 'liquefaction.liquefaction_flaring_ch4',
            type: 'text',
            value: '816.54',
          },
          {
            label: 'Flaring CO2 emissions',
            unit: 'Ton/yr',
            key: 'liquefaction.liquefaction_flaring_co2',
            type: 'text',
            value: '369677',
          },
        ],
      },
      {
        title: 'Fugitives & venting',
        collapsible: true,
        fields: [
          {
            label: 'Fugitives CH4 emissions',
            unit: 'Ton/yr',
            key: 'liquefaction.liquefaction_fugitives_ch4',
            type: 'text',
            value: '159.79',
          },
          {
            label: 'Fugitives CO2 emissions',
            unit: 'Ton/yr',
            key: 'liquefaction.liquefaction_fugitives_co2',
            type: 'text',
            value: '0',
          },
          {
            label: 'Venting CH4 emissions',
            unit: 'Ton/yr',
            key: 'liquefaction.liquefaction_venting_ch4',
            type: 'text',
            value: '0',
          },
          {
            label: 'Venting CO2 emissions',
            unit: 'Ton/yr',
            key: 'liquefaction.liquefaction_venting_co2',
            type: 'text',
            value: '0',
          },
        ],
      },
      {
        title: 'Liquefaction Throughput',
        collapsible: true,
        fields: [
          {
            label: 'NG received',
            unit: 'Mcf/yr',
            key: 'liquefaction.liquefaction_throughput',
            type: 'text',
            value: '871837664',
          },
        ],
      },
    ],
  },
};

export const shippingConfig: FormConfig = {
  title: 'Shipping',
  options: [],
  sectionsByOption: {
    default: [
      {
        title: 'Fuel Use',
        collapsible: true,
        fields: [
          {
            label: 'Shipping Distance',
            unit: 'km',
            key: 'shipping.shipping_distance',
            type: 'text',
            value: '',
            readonly: true,
          },
          {
            label: 'LNG tanker type',
            key: 'shipping.lng_tanker_type',
            type: 'select',
            // options: [
            //   'Abadi Brunei Gas Carriers',
            //   'Mitsubishi',
            //   'Celsius Canberra',
            //   'Celsius Shipping',
            //   'Samsung',
            // ],
            options: [
              { key: 'steam', label: 'Steam', value: 'steam' },
              { key: 'x-df', label: 'X-DF', value: 'x-df' },
            ],
            value: 'steam',
          },
          {
            label: 'Number of days spent maneuvering',
            unit: 'Days',
            key: 'shipping.days_spent_maneuvering',
            type: 'text',
            value: '1.7',
          },
          {
            label: 'Number of days docked (for loading, unloading, refueling)',
            unit: 'Days',
            key: 'shipping.days_docked',
            type: 'text',
            value: '3.3',
          },
          {
            label:
              'Ballast remaining in containment after unloading at destination',
            unit: '% of carrier capacity',
            key: 'shipping.ballast_remaining_percentage',
            type: 'text',
            value: '0.025',
          },
          {
            label: 'LNG tanker capacity',
            unit: 'm3 LNG',
            key: 'shipping.tanker_capacity',
            type: 'text',
            value: '137000',
            readonly: true,
          },
          {
            label: 'Boil-off generation',
            unit: 'ton',
            key: 'shipping.boiloff_generation',
            type: 'text',
            value: '4639.67',
            readonly: true,
          },
          {
            label: 'Boiloff generation while underway from generators',
            unit: 'ton',
            key: 'shipping.boiloff_generation_while_underway_from_generators',
            type: 'text',
            value: '1073.69',
            readonly: true,
          },
          {
            label: 'Boiloff generation while underway from propulsion',
            unit: 'ton',
            key: 'shipping.boiloff_generation_while_underway_from_propulsion',
            type: 'text',
            value: '3317.61',
            readonly: true,
          },
          {
            label: 'Boiloff generation while underway from GCU',
            unit: 'ton',
            key: 'shipping.boiloff_generation_while_underway_from_GCU',
            type: 'text',
            value: '0',
            readonly: true,
          },
          {
            label: 'Boiloff generation while maneuvering from generators',
            unit: 'ton',
            key: 'shipping.boiloff_generation_while_maneuvering_from_generators',
            type: 'text',
            value: '44.93',
            readonly: true,
          },
          {
            label: 'Boiloff generation while maneuvering from propulsion',
            unit: 'ton',
            key: 'shipping.boiloff_generation_while_maneuvering_from_propulsion',
            type: 'text',
            value: '0',
            readonly: true,
          },
          {
            label: 'Boiloff generation while maneuvering from GCU',
            unit: 'ton',
            key: 'shipping.boiloff_generation_while_maneuvering_from_GCU',
            type: 'text',
            value: '71.38',
            readonly: true,
          },
          {
            label: 'Boiloff generation while docked from generators',
            unit: 'ton',
            key: 'shipping.boiloff_generation_while_docked_from_generators',
            type: 'text',
            value: '103.99',
            readonly: true,
          },
          {
            label: 'Boiloff generation while docked from propulsion',
            unit: 'ton',
            key: 'shipping.boiloff_generation_while_docked_from_propulsion',
            type: 'text',
            value: '0',
            readonly: true,
          },
          {
            label: 'Boiloff generation while docked from GCU',
            unit: 'ton',
            key: 'shipping.boiloff_generation_while_docked_from_GCU',
            type: 'text',
            value: '28.07',
            readonly: true,
          },
          {
            label: 'Methane slip while underway from generators',
            unit: 'ton',
            key: 'shipping.methane_slip_while_underway_from_generators',
            type: 'text',
            value: '89.55',
            readonly: true,
          },
          {
            label: 'Methane slip while underway from propulsion',
            unit: 'ton',
            key: 'shipping.methane_slip_while_underway_from_propulsion',
            type: 'text',
            value: '0.17',
            readonly: true,
          },
          {
            label: 'Methane slip while underway from GCU',
            unit: 'ton',
            key: 'shipping.methane_slip_while_underway_from_GCU',
            type: 'text',
            value: '0',
            readonly: true,
          },
          {
            label: 'Methane slip while maneuvering from generators',
            unit: 'ton',
            key: 'shipping.methane_slip_while_maneuvering_from_generators',
            type: 'text',
            value: '3.69',
            readonly: true,
          },
          {
            label: 'Methane slip while maneuvering from propulsion',
            unit: 'ton',
            key: 'shipping.methane_slip_while_maneuvering_from_propulsion',
            type: 'text',
            value: '0',
            readonly: true,
          },
          {
            label: 'Methane slip while maneuvering from GCU',
            unit: 'ton',
            key: 'shipping.methane_slip_while_maneuvering_from_GCU',
            type: 'text',
            value: '0',
            readonly: true,
          },
          {
            label: 'Methane slip while docked from generators',
            unit: 'ton',
            key: 'shipping.methane_slip_while_docked_from_generators',
            type: 'text',
            value: '9.14',
            readonly: true,
          },
          {
            label: 'Methane slip while docked from propulsion',
            unit: 'ton',
            key: 'shipping.methane_slip_while_docked_from_propulsion',
            type: 'text',
            value: '0',
            readonly: true,
          },
          {
            label: 'Methane slip while docked from GCU',
            unit: 'ton',
            key: 'shipping.methane_slip_while_docked_from_GCU',
            type: 'text',
            value: '0',
            readonly: true,
          },
        ],
      },
    ],
  },
};

export const emissionAllocationConfig: FormConfig = {
  title: 'Emission Allocation and Gas Property',
  options: [],
  sectionsByOption: {
    default: [
      {
        title: 'Emission Allocation Methods',
        collapsible: true,
        fields: [
          {
            label: 'Emission allocation method',
            type: 'select',
            key: 'allocation_methods.emission_allocation_method',
            options: [
              'Fully assigned to LNG',
              'Energy-based emission allocation',
            ],
            value: 'Fully assigned to LNG',
          },
          {
            label: 'Contribution of crude oil from production',
            unit: '%',
            key: 'allocation_methods.contribution_of_crude_oil_from_production',
            type: 'text',
            value: '0',
            readonly: true,
          },
          {
            label: 'Contribution of lease condensate from G&B',
            unit: '%',
            key: 'allocation_methods.contribution_of_lease_condensate_from_gathering',
            type: 'text',
            value: '0',
            readonly: true,
          },
          {
            label: 'Contribution of NGL from processing',
            unit: '%',
            key: 'allocation_methods.contribution_of_ngl_from_processing',
            type: 'text',
            value: '2.5',
            readonly: true,
          },
          {
            label: 'Contribution of pipeline gas',
            unit: '%',
            key: 'allocation_methods.contribution_of_pipeline_gas',
            type: 'text',
            value: '97.5',
            readonly: true,
          },
        ],
      },
      {
        title: 'Gas Property',
        collapsible: true,
        fields: [
          {
            label: 'Carbon number in flowback gas',
            unit: '%',
            key: 'gas_properties.carbon_number_in_flowback_gas',
            type: 'text',
            value: '1',
            readonly: true,
          },
          {
            label: 'Mole fraction of CH4 in flowback gas',
            unit: '%',
            key: 'gas_properties.mole_fraction_of_ch4_in_flowback_gas',
            type: 'text',
            value: '54.2',
            readonly: true,
          },
          {
            label: 'Mole fraction of CO2 in flowback gas',
            unit: '%',
            key: 'gas_properties.mole_fraction_of_co2_in_flowback_gas',
            type: 'text',
            value: '1.18',
            readonly: true,
          },
          {
            label: 'Heating value of crude oil',
            unit: 'MMBtu/bbl',
            key: 'gas_properties.heating_value_of_crude_oil',
            type: 'text',
            value: '5.6',
            readonly: true,
          },
          {
            label: 'Heating value of lease condensate',
            unit: 'MMBtu/bbl',
            key: 'gas_properties.heating_value_of_lease_condensate',
            type: 'text',
            value: '4.88',
            readonly: true,
          },
          {
            label: 'Heating value of produced natural gas',
            unit: 'Btu/scf',
            key: 'gas_properties.heating_value_of_produced_ng',
            type: 'text',
            value: '1224',
            readonly: true,
          },
          {
            label: 'Heating value of pipeline gas',
            unit: 'Btu/scf',
            key: 'gas_properties.heating_value_of_pipeline_gas',
            type: 'text',
            value: '1031',
            readonly: true,
          },
          {
            label: 'Heating value of NGL',
            unit: 'MMBtu/bbl',
            key: 'gas_properties.heating_value_of_ngl',
            type: 'text',
            value: '3.82',
            readonly: true,
          },
          {
            label: 'Mole fraction of CH4 in produced gas',
            unit: '%',
            key: 'gas_properties.mole_fraction_of_ch4_in_produced_gas',
            type: 'text',
            value: '82.57',
            readonly: true,
          },
          {
            label: 'Heating value of LNG as natural gas',
            unit: 'Btu/scf',
            key: 'gas_properties.heating_value_of_lng_as_natural_gas',
            type: 'text',
            value: '1036',
            readonly: true,
          },
        ],
      },
    ],
  },
};

export const shippingDistance = {
  spl: {
    'Dalian, China': '10137',
    'Shanghai, China': '10081',
    'Tokyo, Japan': '9209',
    'Osaka, Japan': '9481',
    'Incheon, South Korea': '9998',
    'Busan, South Korea': '9584',
    'Cochin, India': '9840',
    Singapore: '11617',
    'London, UK': '4933',
    'Amsterdam, Netherlands': '5002',
    'Barcelona, Spain': '5205',
    'Dublin, Ireland': '4627',
  },
  ccl: {
    'Dalian, China': '10206',
    'Shanghai, China': '10150',
    'Tokyo, Japan': '9278',
    'Osaka, Japan': '9550',
    'Incheon, South Korea': '10067',
    'Busan, South Korea': '9653',
    'Cochin, India': '9977',
    Singapore: '11754',
    'London, UK': '5070',
    'Amsterdam, Netherlands': '5139',
    'Barcelona, Spain': '5342',
    'Dublin, Ireland': '4764',
  },
};
